import styled from 'styled-components';
import { Flex } from '../Core';

export const DrawerHeader = styled(Flex)`
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacing8}px ${theme.spacing16}px`};
  min-height: 3.5rem;
  border-bottom: solid 1px ${({ theme }) => theme.colors.gray['010']};
  align-items: center;
  gap: ${({ theme }) => theme.spacing4}px;
`;
